module.exports = {
lines:[
    {
        chunks: {
            line_0_cell_0: {
                x: 25,
                y: 333
            },
            line_0_cell_1: {
                x: 218,
                y: 333
            },
            line_0_cell_2: {
                x: 416,
                y: 333
            },
            line_0_cell_3: {
                x: 614,
                y: 333
            },
            line_0_cell_4: {
                x: 812,
                y: 333
            },
            line_0_gap_0: {
                x: 211,
                y: 333
            },
            line_0_gap_1: {
                x: 409,
                y: 333
            },
            line_0_gap_2: {
                x: 607,
                y: 333
            },
            line_0_gap_3: {
                x: 805,
                y: 333
            }
        },
        trajectory: [
            1,
            1,
            1,
            1,
            1
        ]
    },
    {
        chunks: {
            line_1_cell_0: {
                x: 25,
                y: 164
            },
            line_1_cell_1: {
                x: 218,
                y: 164
            },
            line_1_cell_2: {
                x: 416,
                y: 164
            },
            line_1_cell_3: {
                x: 614,
                y: 164
            },
            line_1_cell_4: {
                x: 812,
                y: 164
            },
            line_1_gap_0: {
                x: 211,
                y: 164
            },
            line_1_gap_1: {
                x: 409,
                y: 164
            },
            line_1_gap_2: {
                x: 607,
                y: 164
            },
            line_1_gap_3: {
                x: 805,
                y: 164
            }
        },
        trajectory: [
            0,
            0,
            0,
            0,
            0
        ]
    },
    {
        chunks: {
            line_2_cell_0: {
                x: 25,
                y: 496
            },
            line_2_cell_1: {
                x: 218,
                y: 496
            },
            line_2_cell_2: {
                x: 416,
                y: 496
            },
            line_2_cell_3: {
                x: 614,
                y: 496
            },
            line_2_cell_4: {
                x: 812,
                y: 496
            },
            line_2_gap_0: {
                x: 211,
                y: 496
            },
            line_2_gap_1: {
                x: 409,
                y: 496
            },
            line_2_gap_2: {
                x: 607,
                y: 496
            },
            line_2_gap_3: {
                x: 805,
                y: 496
            }
        },
        trajectory: [
            2,
            2,
            2,
            2,
            2
        ]
    },
    {
        chunks: {
            line_3_cell_0: {
                x: 25,
                y: 121
            },
            line_3_cell_1: {
                x: 218,
                y: 236
            },
            line_3_cell_2: {
                x: 416,
                y: 439
            },
            line_3_cell_3: {
                x: 619,
                y: 236
            },
            line_3_cell_4: {
                x: 812,
                y: 121
            },
            line_3_end: {
                x: 813,
                y: 237
            },
            line_3_gap_0: {
                x: 200,
                y: 216
            },
            line_3_gap_1: {
                x: 375,
                y: 427
            },
            line_3_gap_2: {
                x: 607,
                y: 427
            },
            line_3_gap_3: {
                x: 794,
                y: 217
            }
        },
        trajectory: [
            0,
            1,
            2,
            1,
            0
        ]
    },
    {
        chunks: {
            line_4_cell_0: {
                x: 25,
                y: 428
            },
            line_4_cell_1: {
                x: 218,
                y: 236
            },
            line_4_cell_2: {
                x: 416,
                y: 105
            },
            line_4_cell_3: {
                x: 614,
                y: 236
            },
            line_4_cell_4: {
                x: 812,
                y: 426
            },
            line_4_gap_0: {
                x: 211,
                y: 420
            },
            line_4_gap_1: {
                x: 387,
                y: 205
            },
            line_4_gap_2: {
                x: 607,
                y: 203
            },
            line_4_gap_3: {
                x: 782,
                y: 419
            }
        },
        trajectory: [
            2,
            1,
            0,
            1,
            2
        ]
    },
    {
        chunks: {
            line_5_cell_0: {
                x: 26,
                y: 207
            },
            line_5_cell_1: {
                x: 218,
                y: 207
            },
            line_5_cell_2: {
                x: 416,
                y: 285
            },
            line_5_cell_3: {
                x: 652,
                y: 207
            },
            line_5_cell_4: {
                x: 812,
                y: 207
            },
            line_5_gap_0: {
                x: 211,
                y: 207
            },
            line_5_gap_1: {
                x: 342,
                y: 237
            },
            line_5_gap_2: {
                x: 607,
                y: 237
            },
            line_5_gap_3: {
                x: 805,
                y: 207
            }
        },
        trajectory: [
            0,
            0,
            1,
            0,
            0
        ]
    },
    {
        chunks: {
            line_6_cell_0: {
                x: 26,
                y: 455
            },
            line_6_cell_1: {
                x: 218,
                y: 426
            },
            line_6_cell_2: {
                x: 416,
                y: 265
            },
            line_6_cell_3: {
                x: 635,
                y: 426
            },
            line_6_cell_4: {
                x: 812,
                y: 455
            },
            line_6_gap_0: {
                x: 211,
                y: 455
            },
            line_6_gap_1: {
                x: 358,
                y: 364
            },
            line_6_gap_2: {
                x: 607,
                y: 362
            },
            line_6_gap_3: {
                x: 805,
                y: 455
            }
        },
        trajectory: [
            2,
            2,
            1,
            2,
            2
        ]
    },
    {
        chunks: {
            line_7_cell_0: {
                x: 25,
                y: 236
            },
            line_7_cell_1: {
                x: 218,
                y: 52
            },
            line_7_cell_2: {
                x: 416,
                y: 52
            },
            line_7_cell_3: {
                x: 614,
                y: 52
            },
            line_7_cell_4: {
                x: 818,
                y: 236
            },
            line_7_end: {
                x: 813,
                y: 196
            },
            line_7_gap_0: {
                x: 176,
                y: 191
            },
            line_7_gap_1: {
                x: 409,
                y: 52
            },
            line_7_gap_2: {
                x: 607,
                y: 52
            },
            line_7_gap_3: {
                x: 805,
                y: 188
            }
        },
        trajectory: [
            1,
            0,
            0,
            0,
            1
        ]
    },
    {
        chunks: {
            line_8_cell_0: {
                x: 25,
                y: 379
            },
            line_8_cell_1: {
                x: 218,
                y: 468
            },
            line_8_cell_2: {
                x: 416,
                y: 593
            },
            line_8_cell_3: {
                x: 614,
                y: 469
            },
            line_8_cell_4: {
                x: 842,
                y: 379
            },
            line_8_end: {
                x: 813,
                y: 427
            },
            line_8_gap_0: {
                x: 150,
                y: 427
            },
            line_8_gap_1: {
                x: 409,
                y: 593
            },
            line_8_gap_2: {
                x: 607,
                y: 593
            },
            line_8_gap_3: {
                x: 805,
                y: 460
            }
        },
        trajectory: [
            1,
            2,
            2,
            2,
            1
        ]
    },
    {
        chunks: {
            line_9_cell_0: {
                x: 24,
                y: 478
            },
            line_9_cell_1: {
                x: 257,
                y: 307
            },
            line_9_cell_2: {
                x: 416,
                y: 307
            },
            line_9_cell_3: {
                x: 614,
                y: 236
            },
            line_9_cell_4: {
                x: 812,
                y: 74
            },
            line_9_gap_0: {
                x: 211,
                y: 427
            },
            line_9_gap_1: {
                x: 409,
                y: 307
            },
            line_9_gap_2: {
                x: 607,
                y: 307
            },
            line_9_gap_3: {
                x: 746,
                y: 165
            }
        },
        trajectory: [
            2,
            1,
            1,
            1,
            0
        ]
    }
]
};



//////////////////
// WEBPACK FOOTER
// ./cfg/lines-config.js
// module id = 28
// module chunks = 0